const paper = [
  { // 录题word
    path: '/paper/record/:id/:schoolId',
    name: 'Operation-Record',
    component: (r) => require(['@/v3/modules/exam/views/recordQuestion/recordQuestion'], r),
  },
  { // 录题pdf
    path: '/paper/record/pdf/:id/:schoolId',
    name: 'Operation-Pdf-Question',
    component: (r) => require(['@/v3/modules/exam/views/recordQuestion/pdfQuestion'], r),
  },
  { // 录题 学科网 QBM
    path: '/paper/record/qbm/:id/:schoolId',
    name: 'Operation-Qbm-Question',
    component: (r) => require(['@/v3/modules/exam/views/recordQuestion/qbmQuestion'], r),
  },
  { // word切题
    path: '/paper/split/:id/:schoolId',
    name: 'Operation-Split-Question',
    component: (r) => require(['@/v3/modules/exam/views/recordQuestion/splitQuestion'], r),
  }
]

export default { paper }